export enum TableColumnLoaderType {
	oneTextRow = "oneTextRow",
	twoTextRows = "twoTextRows",
	menuDots = "menuDots",
	checkbox = "checkbox",
	expand = "expand"
}
